import React from "react";
import { vehicleTypeIconKey } from "./vehicleCatalog.js";

function Wheels() {
  return (
    <>
      <circle cx="25" cy="42" r="4" fill="currentColor" />
      <circle cx="67" cy="42" r="4" fill="currentColor" />
    </>
  );
}

export default function VehicleTypeIcon({ code, className = "" }) {
  const kind = vehicleTypeIconKey(code);
  const body = (() => {
    switch (kind) {
      case "cold":
        return (
          <>
            <rect x="18" y="18" width="40" height="20" rx="3" fill="none" stroke="currentColor" strokeWidth="3" />
            <path d="M38 22v12M32 28h12M34 24l8 8M42 24l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </>
        );
      case "box":
        return <rect x="18" y="17" width="40" height="21" rx="2" fill="none" stroke="currentColor" strokeWidth="3" />;
      case "container":
        return (
          <>
            <rect x="16" y="18" width="43" height="20" rx="1" fill="none" stroke="currentColor" strokeWidth="3" />
            <path d="M24 20v16M32 20v16M40 20v16M48 20v16" stroke="currentColor" strokeWidth="1.6" opacity=".7" />
          </>
        );
      case "platform":
        return <path d="M16 34h48M20 30h34" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />;
      case "trailer":
        return (
          <>
            <rect x="8" y="19" width="29" height="17" rx="2" fill="none" stroke="currentColor" strokeWidth="3" />
            <rect x="40" y="19" width="30" height="17" rx="2" fill="none" stroke="currentColor" strokeWidth="3" />
          </>
        );
      case "small":
        return <path d="M18 34V22h30l8 12H18Z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />;
      case "medium":
        return (
          <>
            <rect x="12" y="20" width="36" height="17" rx="2" fill="none" stroke="currentColor" strokeWidth="3" />
            <path d="M48 24h10l8 13H48V24Z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
          </>
        );
      case "dump":
        return <path d="M15 20h42l-7 17H22L15 20Zm42 10h9v7H53" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />;
      case "van":
        return <path d="M14 20h40l12 12v6H14V20Z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />;
      case "tent":
        return (
          <>
            <path d="M14 19h44v19H14V19Z" fill="none" stroke="currentColor" strokeWidth="3" />
            <path d="M20 20v17M29 20v17M38 20v17M47 20v17" stroke="currentColor" strokeWidth="1.4" opacity=".55" />
          </>
        );
      default:
        return <path d="M15 35V22h38l12 13H15Z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />;
    }
  })();

  return (
    <svg viewBox="0 0 80 52" className={className} aria-hidden="true" focusable="false">
      {body}
      <path d="M58 27h7l7 10H58V27Z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" />
      <Wheels />
    </svg>
  );
}
